/* eslint-disable no-underscore-dangle */
import { CdkColumnDef } from '@angular/cdk/table';
import { Directive, Input } from '@angular/core';

/**
 * Column definition for the table.
 * Defines a set of cells available for a table column.
 */
@Directive({
  selector: '[nColumnDef]',
  providers: [{ provide: CdkColumnDef, useExisting: NColumnDefDirective }],
})
export class NColumnDefDirective extends CdkColumnDef {
  /** Unique name for this column. */
  @Input('nColumnDef') override get name(): string {
    return this._name;
  }

  override set name(name: string) {
    this._setNameInput(name);
  }

  /**
   * Add "n-column-" prefix in addition to "cdk-column-" prefix.
   * In the future, this will only add "n-column-" and columnCssClassName
   * will change from type string[] to string.
   * @docs-private
   */

  protected override _updateColumnCssClassName(): void {
    super._updateColumnCssClassName();
    this._columnCssClassName.push(`n-column-${this.cssClassFriendlyName}`);
  }
}
